import { preloadPostOfficePlacementWithSessionContext } from '@confluence/confluence-post-office-provider/entry-points/preload-placement.ts';

export const preloadPostOfficeConfluenceHomeBanner = async (): Promise<boolean> => {
	return preloadPostOfficePlacementWithSessionContext('confluence-home-banner');
};
